import { render, staticRenderFns } from "./RecipeItemStepImage.vue?vue&type=template&id=738ec186&"
import script from "./RecipeItemStepImage.vue?vue&type=script&lang=js&"
export * from "./RecipeItemStepImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports